function isAnyGlobalCountdownActive() {
  return document.querySelectorAll('[data-countdown-type="weekend"]:not(.hidden)').length > 0;
}

function initializeCountdownTimers() {
  const now = new Date();
  const startOfDay = new Date(now.setHours(0, 0, 0, 0)).toISOString();
  const endOfDay = new Date(now.setHours(23, 59, 59, 999)).toISOString();

  const elements = [
    document.querySelector('[data-countdown-type="daily-pdp"]'),
    document.querySelector('[data-countdown-type="daily-top"]')
  ];

  elements.forEach((el) => {
    if (!el) {
      //console.log('Countdown element not found.');
      return;
    }
    //console.log('Setting start and end time');
    el.setAttribute('start-date', startOfDay);
    el.setAttribute('end-date', endOfDay);
  });
}

function resetSiteHeaderMarginTop() {
  const siteHeader = document.querySelector('.site-header');
  if (siteHeader) {
    siteHeader.style.marginTop = '';
  }
}
let initialSiteHeaderMarginTop = 0;

function cacheInitialSiteHeaderMargin() {
  const siteHeader = document.querySelector('.site-header');
  if (siteHeader) {
    const computedStyle = window.getComputedStyle(siteHeader);
    initialSiteHeaderMarginTop = parseInt(computedStyle.marginTop, 10) || 0;
  }
}

function manuallyAdjustCountdownPosition() {
  const siteHeader = document.querySelector('.site-header');
  const headerHeightContainer = document.querySelector('.header-fixed-height');
  const announcementBar = document.querySelector('.announcement-bar-fixed');
  const dailyBar = document.querySelector('.daily-countdown');
  const weeklyBar = document.querySelector('.weekend-countdown');

  if (!siteHeader || !headerHeightContainer || !dailyBar || !weeklyBar) {
    console.log('Some elements missing for manual adjustment.');
    return;
  }

  resetSiteHeaderMarginTop();
  const computedStyle = window.getComputedStyle(siteHeader);
  const currentMarginTop = parseInt(computedStyle.marginTop, 10) || 0;

  siteHeader.style.marginTop =
    currentMarginTop + dailyBar.clientHeight + weeklyBar.clientHeight + 'px';

  // Update header-fixed-height to match announcement bar height
  const dailyBarHeight = dailyBar.classList.contains('hidden') ? 0 : dailyBar.clientHeight;
  const weeklyBarHeight = weeklyBar.classList.contains('hidden') ? 0 : weeklyBar.clientHeight;
  const bothHidden = weeklyBarHeight == 0 && dailyBarHeight == 0;

  siteHeader.style.marginTop = (currentMarginTop + dailyBarHeight + weeklyBarHeight) + 'px';

  if (announcementBar) {
    if(bothHidden){
      headerHeightContainer.style.height =  siteHeader.offsetHeight + announcementBar?.clientHeight + 'px';
    }else{
      headerHeightContainer.style.height =  announcementBar?.clientHeight + 'px';
    }
  }
}

function toggleDailyCountdownVisibility() {
  const elements = [
    document.querySelector('[data-countdown-type="daily-pdp"]'),
    document.querySelector('[data-countdown-type="daily-top"]')
  ];

  elements.forEach((el, index) => {
    const parent = el?.closest('.daily-countdown');
    const isTopBar = index === 1

    if (!el || !parent) return;
    
    if (!isAnyGlobalCountdownActive()) {
      console.log('No global countdown active – showing daily countdown');
      parent.classList.remove('hidden');
      parent.setAttribute('style', 'display: flex;');

      if (isTopBar) {
        manuallyAdjustCountdownPosition();
      }
    } else {
      parent.classList.add('hidden');
      parent.setAttribute('style', 'display: none !important;');

      if (isTopBar) {
        manuallyAdjustCountdownPosition();
      }
    }
    if (isTopBar) {
        manuallyAdjustCountdownPosition();
    }
  });
}

initializeCountdownTimers();

document.addEventListener('DOMContentLoaded', () => {
  cacheInitialSiteHeaderMargin();
  toggleDailyCountdownVisibility();

  document.addEventListener('countdown:started', () => {
    toggleDailyCountdownVisibility();
  });

  document.addEventListener('countdown:ended', () => {
    toggleDailyCountdownVisibility();
  });
});